module.exports = __webpack_public_path__ + "img/go_play.5b6f2d8d.svg";